<template>
  <div v-if="referralChain && referralChain.length > 0" class="referral-chain" :class="referralChain.length > 3 && 'scroll'">
    <template v-for="(item, index) in referralChain">
      <div class="link-icon" :key="`hardlink${index}`">
        <div v-if="index - 1 <= selfIndex && index > 0" class="referral-icon">
        <span class="iconfont icona-hardlink"></span>
        </div>
        <div v-if="index - 1 > selfIndex" class="referral-icon">
        <span class="iconfont icona-softlink"></span>
        </div>
      </div>
      <div
        class="candidate-info"
        :key="index"
      >
        <div
          v-if="!isAppliedList && (index - selfIndex) === 1"
          class="can-share share-border avatar"
        >
          <el-avatar
            class="referral-chain-photo"
            :src="item.is_candidate ? $DjangoMediaUrl(item.profile_image_url) : item.profile_image_url"
            :class="index === referralChain.length - 1 && 'self'"
            @click.native="onImgClick(index, item)"
            @error="getDefaultProfilePhoto"
          >
            <img :src="$DjangoStaticUrl('images_en/default.jpg')"/>
          </el-avatar>
          <div v-if="index !== (referralChain.length - 1) || !isAppliedList" class="share-icon" >
            <van-icon name="share" />
          </div>
        </div>
        <div
          v-else-if="!isAppliedList && (index - selfIndex) < 3 && (index - selfIndex) > 0"
          class="can-share avatar"
        >
          <el-avatar
            class="referral-chain-photo"
            :class="index === referralChain.length - 1 && 'self'"
            :src="item.is_candidate ? $DjangoMediaUrl(item.profile_image_url) : item.profile_image_url"
            @click.native="onImgClick(index)"
          >
            <img :src="$DjangoStaticUrl('images_en/default.jpg')"/>
          </el-avatar>
        </div>
        <div v-else class="avatar">
          <el-avatar
            class="referral-chain-photo"
            :class="index === referralChain.length - 1 && 'self'"
            :src="item.is_candidate ? $DjangoMediaUrl(item.profile_image_url) : item.profile_image_url"
            @click.native="onImgClick(index)"
          >
            <img :src="$DjangoStaticUrl('images_en/default.jpg')"/>
          </el-avatar>
        </div>
        <div class="info">
          <div v-auto-tooltip class="candidate-name">{{ formatName(item.name) }}</div>
          <div v-auto-tooltip class="candidate-city">{{ item.city?.cityName }}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    referralChain: {
      type: Array,
      required: true
    },
    isAppliedList: {
      type: Boolean,
      default: false
    },
    jobId: {
      type: Number,
      required: true
    },
    companyId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      selfIndex: 2,
      showTips: false,
      showTipsIndex: null
    }
  },
  computed: {

  },
  created () {
    this.referralChain.forEach((element, index) => {
      if (element.self === true) {
        this.selfIndex = index
      }
    })
  },
  methods: {
    onImgClick (index) {
      if (this.isAppliedList) {
        return
      }
      const isAfterSelf = (index - this.selfIndex) === 1
      const isLast = index === (this.referralChain.length - 1)
      if (!isAfterSelf && !isLast) {
        return
      }
      this.toJobDetailPage()
    },
    toJobDetailPage () {
      this.$router.push(`/recruiting/company/${this.companyId}/job/${this.jobId}/job-detail`)
    },
    getDefaultProfilePhoto (e) {
      e.target.src = this.$DjangoStaticUrl('images_en/default.jpg')
    },
    formatName (name) {
      if (_.trim(name) === 'None') {
        return null
      }
      return name
    }
  }
}
</script>

<style lang="scss" scoped>

::-webkit-scrollbar {
  height: 4px;
  border-radius: 4px;
  background: #eaeaea;
}

::-webkit-scrollbar-thumb {
  background: #0096cc;
}

.referral-chain {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;

  .link-icon {
    margin: auto 0;

    .referral-icon {
      width: 32px;
      height: 32px;
      position: relative;
      margin-bottom: 43px;

      > span {
       font-size: 35px;
       color: #0096cc;
      }
    }
  }

  .candidate-info {
    flex-shrink: 0;
    width: 42px;
    text-align: center;

    .share-border {
      .referral-chain-photo {
        border: 1px solid var(--custom-color, #0096cc);
      }
    }

    .avatar {
      height: 36px;

      .self {
        border: 1px solid #0096cc;
      }
    }

    .can-share {
      position: relative;

      .referral-chain-photo {
        width: 36px;
        height: 36px;
        background-color: #fff;
        cursor: pointer;
      }

      .share-icon {
        position: absolute;
        left: 24px;
        top: 24px;
        color: var(--custom-color, #0096cc)
      }
    }

    .referral-chain-photo {
      width: 36px;
      height: 36px;
      background-color: #fff;

      .default-icon {
        font-size: 36px;
        color: #dcdfe6;
      }
    }

    .info {
      margin-top: 2px;
      display: flex;
      flex-direction: column;

      .candidate-name {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 12px;
        line-height: 18px;
        color: #606266;
      }

      .candidate-city {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 12px;
        line-height: 18px;
        color: #909399;
      }
    }

    ::v-deep {
      .el-avatar {
        >img {
          margin: auto;
        }
      }
    }
  }
}

.scroll {
  justify-content: flex-start;
}
</style>
